<template>
  <div id="login">
    <div class="container">
      <div class="top">
        {{ companyName
        }}{{ usertype == 'manager' ? '员工服务平台管理中心' : '员工服务平台' }}
      </div>
      <div class="main">
        <p>
          <el-input
            ref="usernameInput"
            :placeholder="usertype == 'manager' ? '请输入用户名' : '请输入工号'"
            prefix-icon="el-icon-user"
            v-model="user_name"
          >
          </el-input>
        </p>
        <p>
          <el-input
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            type="password"
            v-model="password"
            @keyup.enter.native="loginIn"
          >
          </el-input>
        </p>
        <p class="login-btn">
          <el-button
            :type="usertype == 'manager' ? 'success' : 'primary'"
            @click="loginIn"
            >{{ usertype == 'manager' ? '管理员登录' : '员工登录' }}</el-button
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { managerLogin, managerCompanyName } from '@/api/manager'
import { staffLogin, staffCompanyName } from '@/api/staff'
import { mapGetters } from 'vuex'
export default {
  name: 'login',
  components: {},
  data() {
    return {
      user_name: '',
      password: '',
      parent_company_id: '',
      usertype: '',
    }
  },
  computed: {
    ...mapGetters(['companyName']),
  },
  mounted() {
    let _type = this.$route.params.type || 'staff'
    if (_type != 'staff' && _type != 'manager') {
      this.$router.push({ path: '/login' })
    } else {
      this.usertype = _type
    }
    this.parent_company_id = this.$route.query.id || '11184826'
    this.getCompanyName()
    this.$refs.usernameInput.$el.querySelector('input').focus()
  },
  methods: {
    async getCompanyName() {
      if (this.usertype == 'manager') {
        var { code, result } = await managerCompanyName({
          id: this.parent_company_id,
        })
      } else {
        var { code, result } = await staffCompanyName({
          id: this.parent_company_id,
        })
      }
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.$store.dispatch(
          'xSetCompanyName',
          this.usertype == 'manager' ? result.parent_name : result.name
        )
      }
    },
    loginIn() {
      if (this.usertype == 'manager') {
        this.loginManager()
      } else {
        this.loginSatff()
      }
    },
    async loginSatff() {
      let postData = {
        user_name: this.user_name,
        password: this.password,
        company_id: this.parent_company_id,
      }
      let { code, msg, result } = await staffLogin(postData)
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.$message({
          type: 'success',
          message: msg,
        })
        this.$store.dispatch('xLogin', {
          type: 'staff',
          company_name: result.company_name,
          company_id: this.parent_company_id,
        })
        this.$router.push({ path: '/staff' })
      }
    },
    async loginManager() {
      let postData = {
        user_name: this.user_name,
        password: this.password,
        parent_company_id: this.parent_company_id,
      }
      let { code, msg, result } = await managerLogin(postData)
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.$message({
          type: 'success',
          message: msg,
        })
        this.$store.dispatch('xLogin', {
          type: 'manager',
          router: result.authority_list || [],
          company_list: result.company_list || [],
          company_id: this.parent_company_id,
        })
        if (result.authority_list) {
          this.$router.push({
            path: '/manager/' + result.authority_list[0].menu_path,
          })
        } else {
          this.$router.push({
            path: '/manager/noAuth',
          })
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
#login {
  height: 100%;
}
.container {
  position: relative;
  min-height: 100%;
  background: #f1f1f1;
  padding: 144px 0;
  .top {
    text-align: center;
  }
  .main {
    width: 350px;
    margin: 50px auto 0 auto;
    & > p + p {
      margin-top: 20px;
    }
  }
  .login-btn {
    display: flex;
    justify-content: space-between;
    & > .el-button:first-child {
      width: 100%;
    }
  }
}
</style>
